import {useContext,} from 'react';
import {useAuth} from '../../../../contexts/auth';
import {Field, Panel} from '../../../../layouts';
import {CompanyTypes} from '../../../../types/enums';
import {formatShortDate} from '../../../../utils/date-utils';
import {PurchaseOrderContext} from '../context/PurchaseOrderContext';
import {PricingType} from '../types/PricingType';

export default function PurchaseOrderInformationPanel() {

    const {order} = useContext(PurchaseOrderContext);

    function getPricingTypeDescription() {
        switch (order.details.pricingType) {
            case PricingType.Promo:
                return "Promo";
            case PricingType.Standard:
                return "Standard";
            case PricingType.PriceOverride:
                return "Price Override";
        }
    }

    const {user} = useAuth();
    const isServiceProvider = user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER;

    return (
        <>
            <Panel
                header={'Sage PO Information'}
                className="field-label-35"
            >
                <Field label={'Sage PO Number'}>{order.details.poNumber}</Field>
                <Field label={'Order Type'} visible={!isServiceProvider}>{order.details.orderType}</Field>
                <Field label={'Order Status'}>{order.details.orderStatus}</Field>
                <Field label={'Reason'} visible={!!order.details.holdReason}>{order.details.holdReason}</Field>
                <Field label={'Order Date'}>{formatShortDate(order.details.createdOn)}</Field>
                <Field label={'Sage Material Order #'} visible={!isServiceProvider}>{order.details.moNumber}</Field>
                <Field label={'Retail Order #'} visible={!isServiceProvider}>{order.details.roNumber}</Field>
                <Field label={'Retail Order Date'}
                       visible={!isServiceProvider}>{formatShortDate(order.details.roDate)}</Field>
                <Field label={'Retail Order Dealer'}
                       visible={order.details.retailOrder?.dealerParentCompany !== undefined}>{order.details.retailOrder?.dealerParentCompany}</Field>
                <Field label={'Sales Channel'}
                       visible={order.details.retailOrder?.dealerParentCompany === undefined}>{order.details?.salesChannelName}</Field>
                <Field label={'Pricing'} visible={!isServiceProvider}>{getPricingTypeDescription()}</Field>
                <Field label={'Name'} visible={isServiceProvider}>{order.details.retailOrder?.customerName}</Field>
                <Field label={'Address'}
                       visible={isServiceProvider}>{order.details.retailOrder?.customerAddress1}</Field>
                <Field label={''}
                       visible={isServiceProvider && !!order.details.retailOrder?.customerAddress2}>{order.details.retailOrder?.customerAddress2}</Field>
                <Field label={'City'} visible={isServiceProvider}>{order.details.retailOrder?.customerCityZip}</Field>
                <Field label={'Phone'} visible={isServiceProvider}>{order.details.retailOrder?.customerPhone}</Field>
                <Field label={'Alternate Phone'}
                       visible={isServiceProvider && !!order.details.retailOrder?.customerAlternatePhone}>
                    {order.details.retailOrder?.customerAlternatePhone}
                </Field>
                <Field label={'Email'} visible={isServiceProvider}>
                    <a href={'mailto:' + order.details.retailOrder?.customerEmail}>
                        {order.details.retailOrder?.customerEmail}
                    </a>
                </Field>
            </Panel>
        </>
    );
}
